import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, message } from "antd";
import { useDispatch } from "react-redux";
import useCopy from "use-copy";
import CopyIcon from "../../../images/chat/msg-copy.svg";
import DeleteIcon from "../../../images/chat/msg-delete.png";
import ReplyIcon from "../../../images/chat/msg-reply.svg";
import { deleteMessageService } from "../chat.api";
import { removeMessage } from "../../../actions/message";
import { InReplyContext } from "../Chat";

const MessageActions = ({ isCopy, text, messageId, closeActions }) => {
  const { sessionId } = useParams();
  // eslint-disable-next-line
  const [copied, copy, setCopied] = useCopy(text);
  const { setInReply } = useContext(InReplyContext);

  const dispatch = useDispatch();

  function handleCopyText() {
    copy();

    setTimeout(() => {
      setCopied(false);
      closeActions();
    }, 100);
  }

  function handleReply() {
    setInReply({messageId, text});
    closeActions();
  }

  useEffect(() => {
    if (copied) {
      message.info("متن کپی شد");
    }
  }, [copied]);

  function handleDeleteMessage() {
    deleteMessageService(sessionId, messageId)
      .then((res) => {
        dispatch(removeMessage(messageId));
      })
      .catch((err) => {
        // message.error(
        //   "پیام ها فقط کمتر از ۱ دقیقه از زمان ارسال، قابل حذف شدن هستند."
        // );
      }).finally(() => closeActions());
  }

  return (
    <div className="msg-actions-wrapper">
      <div className="msg-actions-buttons">
        <Button
          type={"text"}
          className="msg-actions-button"
          onClick={handleReply}
        >
          <span>پاسخ دادن</span>
          <img src={ReplyIcon} alt={"پاسخ دادن"} />
        </Button>
        {isCopy && (
          <Button
            type={"text"}
            className="msg-actions-button"
            onClick={handleCopyText}
          >
            <span>کپی</span>
            <img src={CopyIcon} alt={"کپی"} />
          </Button>
        )}
        {messageId && (
          <Button
            type={"text"}
            className="msg-actions-button msg-actions-button-danger"
            onClick={handleDeleteMessage}
          >
            <span>حذف</span>
            <img src={DeleteIcon} alt={"کپی"} />
          </Button>
        )}
        {/* <Button
          type={"text"}
          className="msg-actions-button"
          onClick={closeActions}
        >
          <span>بستن</span>
          <CloseOutlined />
        </Button> */}
      </div>
    </div>
  );
};

export default MessageActions;
